import toast from "react-hot-toast";

export const showSuccess = (message: string) => {
  toast.success(message, {
    duration: 3000,
    style: {
      borderRadius: "8px",
      background: "#4caf50",
      color: "#fff",
    },
  });
};

export const showError = (message: string, status_code?: number) => {

  if (status_code === 403) {
    toast.error("Unauthorized access", {
      duration: 3000,
      style: {
        borderRadius: "8px",
        background: "#f44336",
        color: "#fff",
      },
    });
  } else {
    toast.error(message, {
      duration: 3000,
      style: {
        borderRadius: "8px",
        background: "#f44336",
        color: "#fff",
      },
    });
  }
};

export const showInfo = (message: string) => {
  toast(message, {
    duration: 3000,
    style: {
      borderRadius: "8px",
      background: "#2196f3",
      color: "#fff",
    },
  });
};
